<template>
  <div class="card-compProduto-produto-repeticao">
    <!-- <div class="titulo-fluxos"> COMPONENTES DO PRODUTO </div>
    <div class="subtitulo-fluxos"> Informe quantos e quais componentes o produto terá </div> -->

    <g-titulo-steps
    titulo="COMPONENTES DO PRODUTO"
    subtitulo="Informe quantos e quais componentes o produto terá"
    :imagemEmpresa = imagemEmpresa
    />

    <div class="espacamento-fluxos">
      <g-data-table
      class="data-table-conteudo"
      Titulo="Componentes"
      :colunas="colunasProduto"
      :valores="informacao"
      :NumeroLinhas="8"
      :Filtros="Filtro"
      :Editavel= "false"
      :rowEditor="false"
      v-on:duploClickLinha="abrePopupVisualizacao($event)"
      :key="key"
      :EscondeColunaBotao="true"
      >
      </g-data-table>
    </div>

    <div class="buttons-next-back">
      <div class="button-next">
        <g-button
        tipo="amarelo"
        altura="35px"
        largura="100%"
        negritoTexto 
        @click="step5"
        >
          CONTINUAR
        </g-button>
      </div>

      <div class="button-back">
        <g-button 
        tipo="cinza" 
        altura="35px"
        largura="100%"
        negritoTexto 
        v-on:acao="voltarstep3" 
        >
          VOLTAR
        </g-button>
      </div>
      <div class="button-back">
        <g-button 
        tipo="cinza" 
        altura="35px"
        largura="100%"
        negritoTexto 
        @click="abrePopupCancelarOrcamento"
        >
          CANCELAR
        </g-button>
      </div>
    </div>
  </div>

  <PDialog  class="gama-popup" :modal="true" v-model:visible="popupadicionarcomponente" :style="{ width: '85%', margin: '0 5%', minWidth: '300px', maxWidth: '65em' }">
    <template #header>
      <div class="titulo-formulario"> CONSULTAR COMPONENTE </div>
    </template>

    <div class="adicionar-componentes-conteudo-popup">
      <div class="titulo-grupo-detalhes"> Componente </div>
      <div class="grupo-dados-componente grupo">
        <div class="componente">
          <div class="titulo-conteudo-fluxos"> Componente </div>
          <PDropDown
          :options="TipoComponenteArray"
          v-model="novoComponente.ComponenteTipoTexto"
          disabled
          >
          </PDropDown>
        </div>
      </div>

      <div class="titulo-grupo-detalhes"> Medidas </div>
      <div class="grupo-dados-medidas grupo">
        <div class="medidas-comprimento">
          <div class="titulo-conteudo-fluxos"> Comprimento (cm) </div>
          <PInputNumber
          :value="novoComponente.NumeroComprimento"
          v-model="novoComponente.NumeroComprimento"
          :max="100000000"
          locale="pt-BR"
          :minFractionDigits="2"
          disabled
          >
          </PInputNumber>
        </div>

        <div class="medidas-largura">
          <div class="titulo-conteudo-fluxos"> Largura (cm) </div>
          <PInputNumber
          :value="novoComponente.NumeroLargura"
          v-model="novoComponente.NumeroLargura"
          :max="100000000"
          locale="pt-BR"
          :minFractionDigits="2"
          disabled
          >
          </PInputNumber>
        </div>

        <div class="medidas-altura">
          <div class="titulo-conteudo-fluxos"> Altura (cm) </div>
          <PInputNumber
          :value="novoComponente.NumeroAltura"
          v-model="novoComponente.NumeroAltura"
          :max="100000000"
          locale="pt-BR"
          :minFractionDigits="2"
          disabled
          >
          </PInputNumber>
        </div>

        <div class="medidas-altura-tampa">
          <div class="titulo-conteudo-fluxos"> Altura da Tampa (cm) </div>
          <PInputNumber
          :value="novoComponente.NumeroAlturaTampa"
          v-model="novoComponente.NumeroAlturaTampa"
          :max="100000000"
          locale="pt-BR"
          :minFractionDigits="2"
          disabled
          >
          </PInputNumber>
        </div>

        <div class="medidas-ou-conforme">
          <div class="medidas-ou">
            <div class="titulo-conteudo-fluxos label-ou"> OU </div>
          </div>

          <div class="medidas-conforme">          
            <div class="titulo-conteudo-fluxos"> Conforme </div>
            <PDropDown
            placeholder="Insira a medida"
            :options="MedidaConformeArray"
            @change="limparCamposMedidas"
            v-model="novoComponente.DescricaoMedidasTexto"
            disabled
            >
            </PDropDown>
          </div>
        </div>
      </div>      
      
      <div class="titulo-grupo-detalhes"> Materiais e Características </div>
      <div class="grupo-dados-materiais grupo">
        <div class="material">
          <div class="titulo-conteudo-fluxos"> Material </div>
          <PDropDown
          :options="MaterialArray"
          @change="desativarCamposMateriais"
          disabled
          v-model="novoComponente.DescricaoMaterialTexto"
          >
          </PDropDown>
        </div>

        <div class="materiais-onda">
          <div class="titulo-conteudo-fluxos"> Onda </div>
          <PDropDown
          :options="OndaArray"
          v-model="novoComponente.DescricaoOndaTexto"
          disabled
          >
          </PDropDown>
        </div>

        <div class="capa-externa">
          <div class="titulo-conteudo-fluxos"> Capa Externa </div>
          <PDropDown
          :options="CapaExternaArray"
          v-model="novoComponente.DescricaoCapaExternaTexto"
          disabled
          >
          </PDropDown>
        </div>

        <div class="gramatura-capa-externa">
          <div class="titulo-conteudo-fluxos"> Gramatura Capa Externa </div>
          <PInputNumber
          :value="novoComponente.NumeroGramaturaCapaExterna" 
          v-model="novoComponente.NumeroGramaturaCapaExterna"
          disabled 
          >
          </PInputNumber>
        </div>

        <div class="materiais-papel-onda">
          <div class="titulo-conteudo-fluxos"> Papel de Onda </div>
          <PDropDown
          disabled
          :options="PapelOndaArray"
          v-model="novoComponente.DescricaoPapelOndaTexto"
          >
          </PDropDown>
        </div>

        <div class="materiais-gramatura">
          <div class="titulo-conteudo-fluxos"> Gramatura </div>
          <PInputNumber
          :value="novoComponente.NumeroGramaturaPapelOnda" 
          v-model="novoComponente.NumeroGramaturaPapelOnda"
          disabled 
          >
          </PInputNumber>
        </div>

        <div class="capa-interna">
          <div class="titulo-conteudo-fluxos"> Capa Interna </div>
          <PDropDown
          :options="CapaInternaArray"
          v-model="novoComponente.DescricaoCapaInternaTexto"
          disabled
          >
          </PDropDown>
        </div>

        <div class="gramatura-capa-interna">
          <div class="titulo-conteudo-fluxos"> Gramatura Capa Interna </div>
          <PInputNumber
          :value="novoComponente.NumeroGramaturaCapaInterna" 
          v-model="novoComponente.NumeroGramaturaCapaInterna"
          disabled 
          >
          </PInputNumber>
        </div>
      </div>

      <div class="titulo-grupo-detalhes"> Cores e Acabamento </div>
      <div class="grupo-dados-cores grupo">
        <div class="cor-frente">
          <div class="titulo-conteudo-fluxos"> Cor Frente </div>
          <PDropDown
          :options="CorFrenteArray"
          v-model="novoComponente.DescricaoCoresFrenteTexto"
          disabled
          >
          </PDropDown>
        </div>

        <div class="cor-verso">
          <div class="titulo-conteudo-fluxos"> Cor Verso </div>
          <PDropDown
          :options="CorVersoArray"
          v-model="novoComponente.DescricaoCoresVersoTexto"
          disabled
          >
          </PDropDown>
        </div>

        <div class="cores-acabamento-frente">
          <div class="titulo-conteudo-fluxos"> Acabamento Frente </div>
          <PDropDown
          :options="CorFrenteAcabamentoArray"
          v-model="novoComponente.DescricaoAcabamentoFrenteTexto"
          disabled
          >
          </PDropDown>
        </div>

        <div class="cores-acabamento-verso">
          <div class="titulo-conteudo-fluxos"> Acabamento Verso </div>
          <PDropDown
          :options="CorVersoAcabamentoArray"
          v-model="novoComponente.DescricaoAcabamentoVersoTexto"
          disabled
          >
          </PDropDown>
        </div>
      </div>

      <div class="titulo-grupo-detalhes"> Demais Informações </div>
      <div class="grupo-dados-demaisInfo grupo">
        <div class="demaisInfo-sistema">
          <div class="titulo-conteudo-fluxos"> Sistema <strong class="asterisco-obrigatorio">*</strong></div>
          <PDropDown
          :options="SistemaArray"
          v-model="SistemaSelecionado"
          disabled
          optionLabel="text"
          optionValue="value"
          >
          </PDropDown>
        </div>

        <div class="demaisInfo-unidade">
          <div class="titulo-conteudo-fluxos"> Unidade <strong class="asterisco-obrigatorio">*</strong></div>
          <PDropDown
          v-model="UnidadeSelecionadaSistema"
          :options="UnidadeArray"
          optionLabel="nome"
          optionValue="id"
          disabled
          >
          </PDropDown>
        </div>

        <div class="demaisInfo-produto">
          <div class="titulo-conteudo-fluxos"> Produto <strong class="asterisco-obrigatorio">*</strong></div>
          <PDropDown
            v-model="SistemaId"
            :options="ProdutoSistemaOpcoes"
            optionLabel="codigoSistemaDecricao"
            optionValue="id" 
            placeholder="Selecione a Referência"
            :filter="true"
            disabled
            >
            </PDropDown>
        </div>

        <div class="demaisInfo-numero-prototipo" v-if="this.SistemaSelecionado == 3">
          <div class="titulo-conteudo-fluxos"> Número do protótipo <strong class="asterisco-obrigatorio">*</strong></div>
          <PInputNumber
          placeholder="Selecione..."
          v-model="numeroPrototipoSistema"
          >
          </PInputNumber>
        </div>
      </div>
    </div>
  </PDialog>
  <PDialog :showHeader="false" :closable="false" v-model:visible="popupCancelaOrc" :modal="true">
      <div class="titulo-popup-finalizado popups-consultar-orcamentos"> Deseja cancelar esse orçamento? </div>
      <div class="botoes-popup">
        <div>
          <g-button
          tipo="cinza"
          negritoTexto 
          largura="200px" 
          altura="35px" 
          @click="fechaPopupCancelar"
          >
            NÃO
          </g-button>
        </div>
        <div>
          <g-button
          tipo="amarelo"
          negritoTexto
          largura="200px" 
          altura="35px" 
          @click="cancelaOrcamento"
          >
            SIM
          </g-button>
        </div>
      </div>
    </PDialog>
</template>

<script>
import CompProdutoRepeticao from './CompProdutoRepeticao.js'
export default CompProdutoRepeticao
</script>

<style scoped>
.titulo-grupo-detalhes {
  margin-bottom: 15px;
}

.label-ou {
  text-align: center;
}

@media (min-width: 310px) {
.adicionar-componentes-conteudo-popup {
  padding: 0 10px 50px;
}

.grupo {
  display: flex;
  flex-direction: column;
  row-gap: 15px;
}

.medidas-ou-conforme {
  display: flex;
  flex-direction: column;
  row-gap: 5px;
}

.medidas-ou {
  display: flex;
}
}

@media (min-width:368px) {

}

@media (min-width:400px) {
.adicionar-componentes-conteudo-popup {
  padding: 0 20px 50px;
}
}

@media (min-width: 600px) {
.grupo {
  display: grid;
  grid-column-gap: 20px;
  grid-row-gap: 15px;
}

.componente { width: 60%; }

.grupo-dados-medidas {
  grid-template-columns: repeat(4, minmax(4em, 1fr));
  grid-template-rows: repeat(7, auto);
}
.medidas-comprimento { grid-area: 1 / 1 / 2 / 3; }
.medidas-largura { grid-area: 1 / 3 / 2 / 5; }
.medidas-altura { grid-area: 2 / 1 / 3 / 3; }
.medidas-altura-tampa { grid-area: 2 / 3 / 3 / 5; }

.medidas-ou-conforme { 
  grid-area: 3 / 1 / 4 / 5; 
  display: grid;
  grid-template-columns: repeat(4, minmax(4em, 1fr));
  grid-template-rows: repeat(2, auto);
  row-gap: 0;
  grid-row-gap: 0; 
}
.medidas-ou { grid-area: 1 / 1 / 2 / 5; }
.medidas-conforme { grid-area: 2 / 1 / 3 / 4; }

.grupo-dados-materiais {
  display: grid;
  grid-template-columns: repeat(4, minmax(4em, 1fr));
  grid-template-rows: repeat(4, auto);
  grid-column-gap: 20px;
  grid-row-gap: 20px;
}

.material { grid-area: 1 / 1 / 2 / 3; }
.materiais-onda { grid-area: 1 / 3 / 2 / 5; }
.capa-externa { grid-area: 2 / 1 / 3 / 3; }
.gramatura-capa-externa { grid-area: 2 / 3 / 3 / 5; }
.materiais-papel-onda { grid-area: 3 / 1 / 4 / 3; }
.materiais-gramatura { grid-area: 3 / 3 / 4 / 5; }
.capa-interna { grid-area: 4 / 1 / 5 / 3; }
.gramatura-capa-interna { grid-area: 4 / 3 / 5 / 5; }

.grupo-dados-cores{
  display: grid;
  grid-template-columns: repeat(4, minmax(4em, 1fr));
  grid-template-rows: repeat(2, auto);
  grid-column-gap: 20px;
  grid-row-gap: 20px;
}
.cor-frente{ grid-area: 1 / 1 / 2 / 3; }
.cor-verso{ grid-area: 1 / 3 / 2 / 5; }
.cores-acabamento-frente{ grid-area: 2 / 1 / 3 / 3; }
.cores-acabamento-verso{ grid-area: 2 / 3 / 3 / 5; }
}

@media (min-width: 700px) {

}

@media (min-width: 801px) {
.grupo-dados-medidas {
  grid-template-columns: repeat(6, minmax(4em, 1fr));
  grid-template-rows: repeat(2, auto);
}
.medidas-comprimento { grid-area: 1 / 1 / 2 / 3; }
.medidas-largura { grid-area: 1 / 3 / 2 / 5; }
.medidas-altura { grid-area: 1 / 5 / 2 / 7; }
.medidas-altura-tampa { grid-area: 2 / 1 / 3 / 3; }
.medidas-ou-conforme { 
  grid-area: 2 / 3 / 3 / 7; 
  grid-template-rows: auto;
  grid-column-gap: 20px;
}
.medidas-ou { grid-area: 1 / 1 / 2 / 2; align-self: end; }
.medidas-conforme { grid-area: 1 / 2 / 2 / 5; }
}

@media (min-width: 1025px) {
.componente { width: 50%; }
}

@media (min-width: 1281px) {
.grupo-dados-medidas {
  grid-template-columns: repeat(8, minmax(4em, 1fr));
  grid-template-rows: repeat(2, auto);
}
.medidas-comprimento { grid-area: 1 / 1 / 2 / 3; }
.medidas-largura { grid-area: 1 / 3 / 2 / 5; }
.medidas-altura { grid-area: 1 / 5 / 2 / 7; }
.medidas-altura-tampa { grid-area: 1 / 7 / 2 / 9; }
.medidas-ou-conforme { 
  grid-area: 2 / 1 / 3 / 9; 
  grid-template-columns: repeat(8, minmax(4em, 1fr));
  grid-template-rows: auto;
}
.medidas-ou { grid-area: 1 / 1 / 2 / 2; }
.medidas-conforme { grid-area: 1 / 2 / 2 / 5; }

.grupo-dados-materiais {
  grid-template-columns: repeat(8, minmax(4em, 1fr));
  grid-template-rows: repeat(5, auto);
}
.material { grid-area: 1 / 1 / 2 / 5; }
.materiais-onda { grid-area: 1 / 5 / 2 / 9; }
.capa-externa { grid-area: 2 / 1 / 3 / 5; }
.gramatura-capa-externa { grid-area: 2 / 5 / 3 / 9; }
.materiais-papel-onda { grid-area: 3 / 1 / 4 / 5; }
.materiais-gramatura { grid-area: 3 / 5 / 4 / 9; }
.capa-interna { grid-area: 4 / 1 / 6 / 5; }
.gramatura-capa-interna { grid-area: 4 / 5 / 5 / 9; }

.grupo-dados-cores {
  grid-template-columns: repeat(4, minmax(4em, 1fr));
  grid-template-rows: auto;
}
.cor-frente { grid-area: 1 / 1 / 2 / 2; }
.cor-verso { grid-area: 1 / 2 / 2 / 3; }
.cores-acabamento-frente { grid-area: 1 / 3 / 2 / 4; }
.cores-acabamento-verso { grid-area: 1 / 4 / 2 / 5; }
}

@media (min-width: 1500px) {
.adicionar-componentes-conteudo-popup {
  padding: 0 100px 50px;
}
}

@media (min-width:1800px) {
.espacamento-fluxos {
  padding: 0 13% 25px;
}

.adicionar-componentes-conteudo-popup {
  padding: 0 8% 50px;
}
}

@media (min-width:2000px) {
.espacamento-fluxos {
  padding: 0 20% 25px;
}
}
</style>
